import { Name, PhoneNumber } from '../../../../constant/languange'
import { connect, mapStateToProps } from '../../../../helpers/Common'

const EmergencyContacts = ({ redux, val }) => {
  return (
    <div className='table-responsive my-3 text-center'>
      <table className={`table table-sm ${redux.darkModeOn ? 'table-dark bg-dark' : ''}`}>
        <thead>
          <tr>
            <th scope='col' className='text-center align-middle' style={{ minWidth: 150 }}>{Name}</th>
            <th scope='col' className='text-center align-middle' style={{ minWidth: 150 }}>{PhoneNumber}</th>
          </tr>
        </thead>
        <tbody>
          {val.map((item, i) => (
            <tr key={i}>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{item?.name}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{item?.phone_no}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default connect(mapStateToProps)(EmergencyContacts)
